import React, { useState, useEffect, useContext } from "react";
import "./style.scss";
import {
  useAttachAddOnServices,
  useGetListAddOns,
  useListAddOnServices,
  useUpsertAddOnServiceToSku,
} from "../../../hooks/useOrderBatches";
import checkIcon from "../../../assets/AddOnServices/check-circle.svg";
import Button from "../../../common/Button";
import { useNavigate, useParams } from "react-router-dom";
import BackIcon from "../../../assets/Header/backIcon.svg";
import { message } from "antd";
import { BatchMarketPlaceContext } from "../../../context/batchProvider";

const VariantRow = ({ variants, onVariantClick, activeVariantId }) => {
  return (
    <div className="variants">
      <div className="variant_wrapper">
        <div className="button_wrapper">
          {variants.map((variant) => (
            <button
              key={variant?._id}
              className={`variant_button ${
                variant?._id === activeVariantId ? "active" : ""
              }`}
              onClick={() => onVariantClick(variant)}
            >
              {variant?.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

const Service = ({
  service,
  handleAddServices,
  selectedServices,
  isSelected,
  setIsListAddOns,
  updateAddOn,
  skuId,
  skuListData
}) => {
  const [activeVariant, setActiveVariant] = useState(
    service?.items[0]?.variants[2] || service?.items[0]?.variants[0]
  );
  const [selectedPackageId, setSelectedPackageId] = useState(
    service?.items[0]?.packageId
  );
  const [comment, setComment] = useState("");
  const navigate = useNavigate();
  const params = useParams();

  const { batch_selectedAddOnServices, batch_setSelectedAddOnServices } =
    useContext(BatchMarketPlaceContext);

  const handleVariantClick = (variant) => {
    setActiveVariant(variant);

    // Update the variant if the service is already in selected list
    batch_setSelectedAddOnServices((prevServices) =>
      prevServices.map((s) =>
        s.serviceId === service?._id?.serviceId
          ? { ...s, variantId: variant?._id, comments: comment }
          : s
      )
    );
  };

  const handlePackageChange = (e) => {
    const selectedPackage = e.target.value;
    const selectedPackageDetails = service?.items.find(
      (item) => item.packageId === selectedPackage
    );
    const defaultVariant = selectedPackageDetails?.variants[0];

    setSelectedPackageId(selectedPackage);
    setActiveVariant(defaultVariant);
    batch_setSelectedAddOnServices((prevServices) =>
      prevServices.map((s) =>
        s.serviceId === service?._id?.serviceId
          ? {
              ...s,
              packageId: selectedPackage,
              variantId: defaultVariant?._id,
              comments: comment,
            }
          : s
      )
    );
  };

  return (
    <div
  className={`list_item ${
    selectedServices?.some(
      (selected) =>
        selected?.serviceId === service?._id?.serviceId &&
        skuListData?.some(
          (sku) =>
            sku?.serviceId === selected?.serviceId &&
            sku?.packageId === selected?.packageId &&
            sku?.variantId === selected?.variantId
        )
    )
      ? "service_selected"
      : ""
  }`}
  key={service?.id}
>
      <div className="column_wrappers">
        <div className="left_wrapper">
          <h2 className="service_name">{service?._id?.serviceName}</h2>
          {service?.items.length > 1 && (
            <div className="packageName">
              <select
                value={selectedPackageId}
                onChange={handlePackageChange}
                className="package_section"
              >
                {service?.items.map((item) => (
                  <option key={item?.packageId} value={item?.packageId}>
                    {item?.packageName}
                  </option>
                ))}
              </select>
            </div>
          )}

          <VariantRow
            variants={
              service?.items.find(
                (item) => item.packageId === selectedPackageId
              )?.variants || []
            }
            onVariantClick={handleVariantClick}
            activeVariantId={activeVariant?._id}
          />

          <div className="features">
            <h4>Includes:</h4>
            <ul className="item_wrapper">
              {activeVariant?.features?.map((feature, index) => (
                <li key={index} className="item">
                  <img src={checkIcon} alt="" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          <div className="comment_box">
            <textarea
              placeholder="Write Subjective Retouching Information"
              name="reason"
              value={comment}
              onChange={(e) => {
                setComment(e?.target?.value);
              }}
            />
          </div>
        </div>

        <div className="right_wrapper">
          {activeVariant?.images && activeVariant?.images?.length > 0 ? (
            <div className="images_wrapper">
              {activeVariant?.images?.map((image, index) => (
                <>
                  <img
                    key={index}
                    src={image?.thumbPath?.url}
                    alt={`Variant ${activeVariant?.name} Image ${index + 1}`}
                    className="variant_image"
                  />
                </>
              ))}
            </div>
          ) : (
            <p>No images available for this variant.</p>
          )}
        </div>
      </div>

      <div className="action_buttons">
        {/* <button
          className="skip_btn"
          onClick={() => navigate(`/upload-images/${params.batchId}`)}
        >
          Skip
        </button> */}

        <Button
          width="115px"
          height="45px"
          text="Add"
          showIcon={false}
          handleClick={() => {
            handleAddServices({
              packageId: selectedPackageId,
              serviceId: service?._id?.serviceId,
              variantId: activeVariant?._id,
              comments: comment,
            });
          }}
        />
      </div>
    </div>
  );
};

const FilteredAddOnServices = ({ skuId, isServiceAdded, skuListData }) => {
  const [servicesList, setServicesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const navigate = useNavigate();
  const params = useParams();
  // const [selectedServices, setSelectedServices] = useState([]);

  const { batch_selectedAddOnServices, batch_setSelectedAddOnServices } =
    useContext(BatchMarketPlaceContext);

  const onSuccessListAddOnServices = (res) => {
    setServicesList(res?.data?.data || []);
    setLoading(false);
  };

  const onErrorListAddOnServices = (err) => {
    console.error("Error fetching services:", err);
  };

  const { data: getAllServicesList } = useGetListAddOns(
    "getAllServicesList",
    skuId,
    onSuccessListAddOnServices,
    onErrorListAddOnServices
  );

  const onSuccessUpsertAddOnServiceToSku = (res) => {
    if (res.status === 200) {
      message.success("Add-On Updated");
      setTimeout(() => {
        isServiceAdded();
      });
      navigate(`/sku-list/${params.batchId}`);
    }
  };

  const onErrorUpsertAddOnServiceToSku = (err) => {
    message.error(err);
  };

  const { mutate: upsertAddOnServiceToSku } = useUpsertAddOnServiceToSku(
    onSuccessUpsertAddOnServiceToSku,
    onErrorUpsertAddOnServiceToSku
  );
  const updateAddOn = (skuId, serviceId, packageId, variantId, comment) => {
    let payload = {
      draftSkuId: skuId,
      serviceId: serviceId,
      packageId: packageId,
      variantId: variantId,
      comments: [comment],
    };
    upsertAddOnServiceToSku(payload);
  };

  useEffect(() => {}, [servicesList]);

  const handleAddServices = ({ packageId, serviceId, variantId, comments }) => {
    batch_setSelectedAddOnServices((prevServices) => {
      const isSelected = prevServices?.some(
        (service) =>
          service.serviceId === serviceId &&
          service.packageId === packageId &&
          service.variantId === variantId
      );

      if (isSelected) {
        return prevServices.filter(
          (service) =>
            !(
              service.serviceId === serviceId &&
              service.packageId === packageId &&
              service.variantId === variantId
            )
        );
      }

      return [...prevServices, { packageId, serviceId, variantId, comments }];
    });
    updateAddOn(skuId, serviceId, packageId, variantId, comments);
  };

  const onSuccessAttachAddOnServices = (res) => {
    if (res.status === 200) {
      navigate(`/upload-images/${params?.batchId}`, {
        state: { from: "add-on-services" },
      });
    } else {
      message.error("Error");
    }
  };
  const onErrorAttachAddOnServices = (err) => {
    message.error(err);
  };
  const { mutate: attachAddOnServices } = useAttachAddOnServices(
    onSuccessAttachAddOnServices,
    onErrorAttachAddOnServices
  );

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error?.message}</div>;
  }

  // const handleAttachAddOnServices = () => {
  //   let payload = {
  //     batchId: params?.batchId,
  //     updateAddOnServices: batch_selectedAddOnServices,
  //   };
  //   attachAddOnServices(payload);
  // };

  const showDetails = batch_selectedAddOnServices?.map(
    (selectedService, index) => {
      const selectedServiceDetails = servicesList?.find(
        (service) => service?._id?.serviceId === selectedService?.serviceId
      );

      const selectedPackage = selectedServiceDetails?.items?.find(
        (item) => item.packageId === selectedService?.packageId
      );

      const selectedVariant = selectedPackage?.variants?.find(
        (variant) => variant._id === selectedService?.variantId
      );

      return selectedServiceDetails && selectedPackage && selectedVariant ? (
        <li key={index} className="service_name">
          <div className="package_details">
            <p>
              {selectedServiceDetails?._id?.serviceName}
              {selectedServiceDetails?.items.length > 1
                ? `(${selectedPackage?.packageName})`
                : ""}
            </p>
            <p>{selectedVariant?.name}</p>
          </div>
          <div
            className="cross-icon"
            onClick={() => {
              batch_setSelectedAddOnServices((prevServices) =>
                prevServices.filter(
                  (service) =>
                    !(
                      service?.serviceId === selectedService?.serviceId &&
                      service?.packageId === selectedService?.packageId &&
                      service?.variantId === selectedService?.variantId
                    )
                )
              );
            }}
          ></div>
        </li>
      ) : null;
    }
  );

  return (
    <div className="filtered_addon_services">
      <div className="services_head">
        <h2 className="title">
          Need Additional Retouching on Images? Add-On Services Available!
        </h2>
      </div>
      <div className="services_list">
        {servicesList?.map((service) => (
          <Service
            key={service?._id?.serviceId}
            service={service}
            handleAddServices={handleAddServices}
            selectedServices={batch_selectedAddOnServices}
            isSelected={batch_selectedAddOnServices?.some(
              (selected) =>
                selected?.serviceId === service?._id?.serviceId &&
                selected?.packageId === service?.items[0]?.packageId &&
                selected?.variantId === service?.items[0]?.variants[0]?._id
            )}
            updateAddOn={updateAddOn}
            skuId={skuId}
            skuListData={skuListData}
          />
        ))}
      </div>
      {/* <div className="action_wrapper">
        <div className="selected_services">
          <ul>
            {showDetails}
          </ul>
        </div>
        <div className="other_actions">
          <button
            className="backBtn"
            onClick={() => navigate(`/sequencing/${params?.batchId}`)}
          >
            <img src={BackIcon} alt="backBtn" />
          </button>
          <Button
            text="Next"
            width="140px"
            height="50px"
            handleClick={() => {
              batch_selectedAddOnServices?.length > 0 && handleAttachAddOnServices();
            }}
          />
        </div>
      </div> */}
    </div>
  );
};

export default FilteredAddOnServices;